import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.div`
  margin: 0 auto;
  max-width: ${theme.unit * 64}px;
  text-align: center;

  ${({ alignLeft }) => alignLeft && `
    @media screen and (min-width: ${alignLeft}) {
      text-align: left;
    }
  `}
`);



// WEBPACK FOOTER //
// ./src/components/blocks/ContainerSmall.js